export const COMPANY_CODES = {
  C001: 'companyNotExist',
  C002: 'companyNameExist',
};
